import highEmphasis from '../../text/high-emphasis';

const light = (params) => highEmphasis(params);

export default light;
